// Action types
export const CHANGE_POP_UP = 'change_pop_up'
export const CHANGE_POP_UP_ERROR = 'change_pop_up_error'

export function changePopUp(visible, action) {
  return {
    type: CHANGE_POP_UP,
    payload: { visible, action }
  }
}

export function changePopUpError(error) {
  return {
    type: CHANGE_POP_UP_ERROR,
    payload: error
  }
}

